"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "formData",
    staticClass: "demo-form modern-left-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Technical Description",
      prop: "shortDescription"
    }
  }, [_c("editor", {
    attrs: {
      "api-key": "no-api-key",
      init: {
        height: 500,
        plugins: ["lists link image paste help wordcount preview table | code"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help"
      }
    },
    model: {
      value: _vm.formData.technicalDescription,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "technicalDescription", $$v);
      },
      expression: "formData.technicalDescription"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Drawing",
      prop: "drawingFile"
    }
  }, [_c("div", {
    staticClass: "drawing-upload-wrapper",
    class: {
      "drawing-upload-wrapper--merger": !_vm.formData.drawingFile
    }
  }, [_vm.formData.drawingFile ? _c("div", {
    staticClass: "drawing-preview"
  }, [_c("img", {
    attrs: {
      src: _vm.formData.drawingFile,
      alt: "Drawing Preview"
    }
  }), _c("div", {
    staticClass: "overlay"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "light"
    },
    on: {
      click: function ($event) {
        _vm.formData.drawingFile = "";
      }
    }
  }, [_vm._v(" Change ")])], 1)]) : _c("image-merger", {
    attrs: {
      "upload-fn": _vm.uploadFile
    },
    on: {
      uploaded: response => _vm.formData.drawingFile = response
    }
  })], 1)]), _c("el-form-item", {
    attrs: {
      label: "License File",
      prop: "licenseAttachment"
    }
  }, [_c("el-upload", {
    attrs: {
      action: "#",
      "auto-upload": false,
      limit: 1,
      "list-type": "text",
      "show-file-list": true,
      "file-list": _vm.licenseFileList,
      "on-change": _vm.handleLicenseChange,
      "on-remove": _vm.handleLicenseRemove,
      "on-preview": _vm.handlePreview
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1), _c("el-dialog", {
    attrs: {
      visible: _vm.previewVisible,
      width: "60%",
      top: "5vh"
    },
    on: {
      "update:visible": function ($event) {
        _vm.previewVisible = $event;
      }
    }
  }, [_vm.isPreviewImage ? _c("img", {
    attrs: {
      width: "100%",
      src: _vm.previewUrl
    }
  }) : _vm.isPreviewPdf ? _c("iframe", {
    attrs: {
      src: _vm.previewUrl,
      width: "100%",
      height: "600"
    }
  }) : _vm.isPreviewDoc ? _c("iframe", {
    attrs: {
      src: "https://docs.google.com/gview?url=" + _vm.previewUrl + "&embedded=true",
      width: "100%",
      height: "600"
    }
  }) : _c("div", [_vm._v(" Preview not supported. Download file. ")])]), _c("el-form-item", {
    attrs: {
      label: "Priority",
      prop: "priority"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "priority",
      placeholder: "Priority",
      min: 0,
      max: 100,
      step: 1,
      precision: 0,
      controls: true
    },
    model: {
      value: _vm.formData.priority,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "priority", $$v);
      },
      expression: "formData.priority"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Tags",
      prop: "tags"
    }
  }, [_vm._l(_vm.formData.tags ? _vm.formData.tags.split(",") : [], function (tag) {
    return _c("el-tag", {
      key: tag,
      attrs: {
        closable: "",
        "disable-transitions": false
      },
      on: {
        close: function ($event) {
          return _vm.handleTagClose(tag);
        }
      }
    }, [_vm._v(" " + _vm._s(tag) + " ")]);
  }), _vm.inputTagVisible ? _c("el-input", {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      size: "mini"
    },
    on: {
      blur: _vm.handleTagInputConfirm
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleTagInputConfirm.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputTagValue,
      callback: function ($$v) {
        _vm.inputTagValue = $$v;
      },
      expression: "inputTagValue"
    }
  }) : _c("el-button", {
    staticClass: "button-new-tag",
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.showTagInput
    }
  }, [_vm._v(" + New Tag ")])], 2), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      loading: _vm.loading,
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;